import { Shield } from 'lucide-react';
import { Helmet } from 'react-helmet-async';

export function Privacy() {
  return (
    <>
      <Helmet>
        <title>Personvern | Aker Stadion Fanside</title>
        <meta 
          name="description" 
          content="Vår personvernerklæring forklarer hvordan vi beskytter og behandler dine personopplysninger på Aker Stadion fansiden."
        />
      </Helmet>
      <div className="min-h-screen bg-gray-100">
        <div className="bg-[#2173B9] text-white py-12">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="flex items-center gap-3 mb-4">
              <Shield className="w-8 h-8" />
              <h1 className="text-3xl font-bold">Personvern og cookies</h1>
            </div>
            <p className="text-lg opacity-90">
              Hvordan vi beskytter dine personopplysninger
            </p>
          </div>
        </div>

        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
          <div className="bg-white rounded-lg shadow-lg p-6">
            <div className="prose max-w-none">
              <h2 className="text-2xl font-bold mb-4">Personvern og cookies</h2>
              <p className="text-gray-600 mb-6">
                Vi tar personvernet ditt på alvor. Denne siden beskriver hvordan vi samler inn, 
                bruker og beskytter dine personopplysninger når du bruker nettsiden vår. Ved å 
                bruke denne nettsiden, godtar du vår bruk av cookies og annen informasjon som 
                beskrevet her.
              </p>

              <h3 className="text-xl font-bold mb-3">Hvilke opplysninger samler vi inn?</h3>
              <p className="text-gray-600 mb-6">
                Vi samler inn informasjon som du gir oss direkte, for eksempel når du fyller ut 
                et kontaktskjema. Dette kan inkludere navn, e-postadresse, telefonnummer og 
                meldingen din. I tillegg bruker vi cookies for å samle inn anonym informasjon om 
                hvordan du bruker nettsiden, slik at vi kan forbedre brukeropplevelsen.
              </p>

              <h3 className="text-xl font-bold mb-3">Hvordan bruker vi opplysningene dine?</h3>
              <p className="text-gray-600 mb-6">
                Opplysningene vi samler inn brukes til å besvare dine henvendelser, forbedre våre 
                tjenester og gi deg relevant informasjon om Aker Stadion og Molde FK. Vi deler ikke 
                dine personopplysninger med tredjeparter uten ditt samtykke, med mindre dette er 
                nødvendig for å levere en tjeneste du har bedt om.
              </p>

              <h3 className="text-xl font-bold mb-3">Cookies</h3>
              <p className="text-gray-600 mb-6">
                Vi bruker cookies for å forbedre din opplevelse på nettsiden. Cookies hjelper oss 
                med å forstå hvordan brukere navigerer på siden, slik at vi kan gjøre forbedringer 
                der det trengs. Du kan velge å deaktivere cookies i nettleseren din, men vær 
                oppmerksom på at dette kan påvirke funksjonaliteten på nettsiden.
              </p>

              <h3 className="text-xl font-bold mb-3">Dine rettigheter</h3>
              <p className="text-gray-600">
                Du har rett til å be om innsyn i hvilke personopplysninger vi har om deg, be om 
                retting eller sletting av disse, og trekke tilbake ditt samtykke til vår bruk av 
                opplysninger. For spørsmål om personvern, kontakt oss via kontaktskjemaet på nettsiden.
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
